
<div :class="jel_getClassObject(content)">
  <component
    :is="'MediaImage' + content.format.replace('mediaImage', '')"
    :key="content.image['@id']"
    :content="content"
  >
  </component>
</div>
